import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { CaretLeft } from "components/icons/CaretLeft";
import { CaretRight } from "components/icons/CaretRight";
import ToolTip from "components/design/toolTip";
import {
  OVERDUE_LABEL,
  OVERDUE_NEXT_YEARS_TOOLTIP,
  OVERDUE_PREVIOUS_YEARS_TOOLTIP,
  TIMELINE_CHIP_BOTTOM,
} from "constants/filingsTimeline";

type TimelineOverdueChipProps = {
  side: "left" | "right";
  count: number;
  onClick: () => void;
};

const CHIP_CLASS =
  "!t-absolute !t-h-[14px] !t-min-h-0 !t-px-0 !t-py-0 !t-text-caption !t-font-medium !t-text-red hover:!t-no-underline focus:!t-ring-0 focus-visible:!t-ring-2 focus-visible:!t-ring-purple-20";

export const TimelineOverdueChip = ({
  side,
  count,
  onClick,
}: TimelineOverdueChipProps) => {
  const isLeft = side === "left";

  const tooltipText = isLeft
    ? OVERDUE_PREVIOUS_YEARS_TOOLTIP
    : OVERDUE_NEXT_YEARS_TOOLTIP;

  return (
    <ToolTip text={tooltipText} side="top" disableHoverableContent>
      <Button
        customType="danger_link"
        size="xxsmall"
        onClick={onClick}
        className={classNames(CHIP_CLASS, isLeft ? "!t-left-6" : "!t-right-6")}
        style={{ bottom: TIMELINE_CHIP_BOTTOM }}
      >
        <span className="t-flex t-items-center t-gap-0.5">
          {isLeft && <CaretLeft width="12" height="12" />}
          {count} {OVERDUE_LABEL}
          {!isLeft && <CaretRight width="12" height="12" strokeWidth="1.4" />}
        </span>
      </Button>
    </ToolTip>
  );
};
